const AgentSystemActionType = {
  GET_AGENT_SYSTEM_HISTORY: 'GET_AGENT_SYSTEM_HISTORY',
  SAVE_AGENT_SYSTEM_HISTORY: 'SAVE_AGENT_SYSTEM_HISTORY',
  RESET_AGENT_SYSTEM_HISTORY: 'RESET_AGENT_SYSTEM_HISTORY',

  RESEND_AGENT_SYSTEM_DATA: 'RESEND_AGENT_SYSTEM_DATA',
};

export default AgentSystemActionType;
